const CommonCloseBtn = ({ onClose }) => {
  return (
    <div className="flex justify-end pr-3">
      <button
        type="button"
        onClick={onClose}
        aria-label="Close modal"
        style={{
          fontSize: "28px",
          color: "#333",
          background: "transparent",
          border: "none",
          cursor: "pointer",

        }}
      >
        &times;
      </button>
    </div>
  );
};

export default CommonCloseBtn;
